import GameModel from 'Models/GameModel';
import { executeAfterLoad } from 'Root/helpers/tools';

const WOW_TOOLTIP_URL = 'https://wow.zamimg.com/js/tooltips.js';
const DESTINY_TOOLTIP_URL = '/js_external/destinyTooltips.js';

const createHTMLScript = (link, id) => {
  const tooltipScript = document.createElement('script');
  tooltipScript.type = 'text/javascript';
  tooltipScript.defer = true;
  if (id) {
    tooltipScript.id = id;
  }
  tooltipScript.setAttribute('src', link);
  document.head.appendChild(tooltipScript);
};

export default {
  mounted() {
    executeAfterLoad(() => {
      let tooltipFlag;
      // WOW
      if (window._skycoach_tooltips?.wow !== true && (
        GameModel.LIST_WOW_ALL_IDS.includes(this.$store.state.activeGame.id)
        || GameModel.LIST_WOW_ALL_IDS.includes(this.$store.state?.blog?.activeGame?.id))) {
        // init wow tooltip
        window.whTooltips = { colorlinks: true, iconizelinks: true, renamelinks: true };
        createHTMLScript(WOW_TOOLTIP_URL);
        tooltipFlag = 'wow';
      }
      // DESTINY
      if (window._skycoach_tooltips?.destiny !== true && (
        this.$store.state.activeGame.id === GameModel.DESTINY.id
        || this.$store.state?.blog?.activeGame?.id === GameModel.DESTINY.id)) {
        // init destiny tooltip
        window.lggTT = { recolorLinks: false, darkMode: true };
        createHTMLScript(DESTINY_TOOLTIP_URL, 'destiny-tooltips');
        tooltipFlag = 'destiny';
      }

      if (!window._skycoach_tooltips) {
        window._skycoach_tooltips = {};
      }
      window._skycoach_tooltips[tooltipFlag] = true;
    });
  },
};
